import React from "react";

import { Button, notification } from "antd";

import { useDepositMoneyWithMobileMoneyMutation } from "store/api";

import InputField from "components/Common/InputField";
import { Formik } from "formik";
import * as Yup from "yup";
import { ErrorAlert } from "components/Common";
import { useSelector } from "react-redux";
import { selectUser } from "store/slices";
import { Link } from "react-router-dom";

const MobileDepositForm = ({
  onClose,
  refetch,
}: {
  onClose: any;
  refetch?: any;
}) => {
  const [error, setError] = React.useState<string | null>(null);
  const user = useSelector(selectUser);

  const [depositMoneyWithMobileMoney, { isLoading }] =
    useDepositMoneyWithMobileMoneyMutation();

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="w-full h-full flex flex-col justify-center">
        <Formik
          validateOnBlur
          initialValues={{
            amount: "",
            paymentMethod: "mobile",
            accountNumber: "",
          }}
          validationSchema={Yup.object().shape({
            amount: Yup.string().required("Amount is required"),
            paymentMethod: Yup.string().required("Payment method is required"),
          })}
          onSubmit={async (values) => {
            try {
              await depositMoneyWithMobileMoney({
                currency: "EUR",
                externalId: `MM-${Date.now()}`,
                payerMessage: "Saving Deposit",
                amount: values.amount,
                paymentMethod: values.paymentMethod,
                payerPhone: user?.phone,
                payeeNote: values.accountNumber,
                userId: user?.id,
              }).unwrap();

              notification.success({
                message: "Success",
                description: "Your transaction has been successful",
              });
              onClose();
              refetch();
            } catch (error: any) {
              setError(error?.data?.error || "Error");
            }
          }}
        >
          {({ handleSubmit, isValid, dirty }) => (
            <form onSubmit={handleSubmit} className="space-y-3">
              <ErrorAlert
                type="warning"
                message={
                  <span>
                    This feature is still under testing, please{" "}
                    <Link to="../submit-deposit">click here</Link> to make
                    deposit
                  </span>
                }
                setMessage={() => {}}
              />
              <ErrorAlert type="error" message={error} setMessage={setError} />

              <InputField
                label="Account Number"
                name="accountNumber"
                type="select"
                currencyOptions={[
                  { value: user?.accountNumber, label: user?.accountNumber },
                ]}
                placeholder="Select Account Number"
              />
              <InputField
                label="Enter Amount To Deposit"
                name="amount"
                type="text"
                placeholder="Enter amount"
              />
              <InputField
                label="Payment Method"
                name="paymentMethod"
                type="radio"
                placeholder="Select Payment Method"
                options={[{ value: "mobile", label: "MTN Mobile Money" }]}
              />

              <Button
                type="primary"
                htmlType="submit"
                className="w-full h-10"
                loading={isLoading}
                disabled={!isValid || !dirty || isLoading}
              >
                Deposit Money
              </Button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default MobileDepositForm;
